import * as angular from "angular";
import {IController} from "angular";

export class BranchesGroupsViewComponent implements IController {

  currentNavItem?: string;
  groupIds?: string[];
  branchIds?: string[];
  tags?: string[];

  constructor(private $state) {
  }

  $onInit() {
    if (!this.currentNavItem) {
      this.currentNavItem = 'Branches';
    }
  }

  changeGroup(currentNavItem) {
    this.currentNavItem = currentNavItem;
    this.groupIds = undefined;
    this.branchIds = undefined;
    this.tags = undefined;

    this.$state.go('.', {
      currentNavItem: this.currentNavItem,
      groupIds: undefined,
      branchIds: undefined,
      tags: undefined
    }, {notify: false, reload: false});
  }

}

angular
  .module('bringoz.admin.commons')
  .component('branchesGroupsView', {
    bindings: {
      currentNavItem: '<?',
      groupIds: '<?',
      branchIds: '<?',
      tags: '<?'
    },
    template: require('./branches-groups-view.html').default,
    controller: BranchesGroupsViewComponent
  });
